import React, { useState, useEffect, useCallback, useRef } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
//imported
import { CATEGORY } from "helpers/viewContent";
import {
    addData_,
    getDetail_,
    updateData_,
} from "store/services/commonService";
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";


const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    boxShadow: 24,
    zIndex: "9999999",
    borderRadius: "16px",
    p: 4,
};

function MessageModel({ open, handleClose, singleSupport, dispatch }) {


    const validationSchema = Yup.object().shape({
        adminReply: Yup.string().required("Reply is required"),
    });

    const validateData = async (data) => {
        try {
            await validationSchema.validate(data, { abortEarly: false });
            return { isValid: true, errors: {} };
        } catch (error) {
            const errors = {};
            error.inner.forEach((err) => {
                errors[err.path] = err.message;
            });
            return { isValid: false, errors };
        }
    };

    const history = useHistory();
    const [isShow, setIsShow] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [fields, setfields] = useState({
        adminReply: "",
    });

    const handleChange = useCallback(
        (name) => (evt) => {
            setfields((prevState) => ({
                ...prevState,
                [name]: evt.target.value,
            }));
            setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        },
        []
    );

    const handleSubmit = async (evt) => {
        try {
            evt.preventDefault();
            const validation = await validateData(fields);
            if (validation.isValid) {
                dispatch(actions.persist_store({ loader: true }));
                setIsShow(true);
                let query = {
                    ...fields,
                    url: "report/updateContact ",
                    adminReply: fields?.adminReply,
                    id: singleSupport,
                    status: "replied"
                };
                await dispatch(addData_(query));
                // return
                setIsShow(false);
                dispatch(actions.persist_store({ loader: false }));
                history.push(`${Path.support_list}`);
                setfields({
                    adminReply: "",
                })
                handleClose();
            } else {
                setValidationErrors(validation.errors);
            }
        } catch (err) {
            setIsShow(false);
            dispatch(actions.persist_store({ loader: false }));
            console.log(err);
        }
    };

    const handleModalClose = () => {
        handleClose();
    };


    return (
        <>
            <Modal
                open={open}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="register-wrapper"
            >
                <Box sx={style} className="">
                    {/* header */}
                    <div className="flex place-content-between items-center border-b border-[#00000026] pb-3 mb-3">
                        <h4 className="font-bold text-[22px] text-[#4F4F4F]">
                            Send Message
                        </h4>

                        {/* <button onClick={handleModalClose}>
                            <i class="mdi mdi-close-circle"></i>
                        </button> */}
                    </div>
                    <form className="forms-sample" onSubmit={handleSubmit}>
                        <div className="row ">
                            <div className="form-group col-md-12">
                                <label for="exampleInputName1">Reply*</label>
                                <textarea
                                    rows={7}
                                    type="text"
                                    className="form-control"
                                    id="exampleInputName1"
                                    placeholder=" Message*"
                                    name="adminReply"
                                    onChange={handleChange("adminReply")}
                                    value={fields.adminReply}
                                />
                                {validationErrors.adminReply && (
                                    <div className="text-danger err">
                                        {validationErrors.adminReply}
                                    </div>
                                )}
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={isShow ? true : false}
                            className="btn btn-gradient-primary me-2"
                        >
                            {isShow ? "Wait.." : "Submit"}
                        </button>

                        <button className="btn btn-outline-secondary btn-lg"
                            onClick={handleModalClose}>
                            Back
                        </button>
                    </form>
                </Box >
            </Modal >
        </>
    );
}

export default MessageModel;

